import React from 'react'
import TimeAgo from 'javascript-time-ago'
import moment from 'moment'
import { momentFullDateFormatWithTimeAndDay } from 'components/common/Constants'
import { LOCALES, currentLocale } from 'components/common/Locales'
Object.values(LOCALES).forEach(locale => TimeAgo.addLocale(locale.timeAgo))

export const TimeAgoElement = (props) => {
  return (
    <span title={moment(props.date).format(momentFullDateFormatWithTimeAndDay)}>{TimeAgoPlain(props.date)}</span>
  )
}

export const TimeAgoPlain = (date) => {
  const timeAgo = new TimeAgo(currentLocale())
  return (
    timeAgo.format(date)
  )
}
